import React, { memo, useCallback } from 'react'
import { useSelector } from 'react-redux'
import { selectorQuiz } from '../../features/quiz/quizSlice.js'
import questionnaire from '../../questionnaire.js'

/**
 * NAV QUIZ COMPONENT
 * @param {{ totalSteps: number, currentStep: number, goToStep: (i: number) => void }} props 
 * @returns {JSX.Element}
 */
function NavQuiz({totalSteps, currentStep, goToStep}) {
  const state = useSelector(selectorQuiz)
  const sections = ['PROFIL ENTREPRISE(1)', 'PROFIL ENTREPRISE(2)', 'PROFIL DIGITAL', 'STRATEGIE DIGITALE']
  const section2 = ['question2', 'question3', 'question4', 'question5', 'question6']
  const section3 = ['question10', 'question11', 'question12', 'question13', 'question14', 'question15', 'question16', 'question17', 'question18', 'question19']

  const shouldBeDisabled = useCallback((step) => {
    
    const questions = questionnaire[`section${step}`].questions

    let alreadyComplete = false
    for (const questionNumber in questions){
      if(!state[questionNumber] && !Array.isArray(state[questionNumber])){
        alreadyComplete = true
        break
      }
      if(!state[questionNumber] && !Array.isArray(state[questionNumber])){
        alreadyComplete = true
        break
      }
      if (Array.isArray(state[questionNumber]) && state[questionNumber].length <= 0){
        alreadyComplete = true
        break
      }
      if (Array.isArray(state[questionNumber]) && state[questionNumber].length <= 0){
        alreadyComplete = true
        break
      }
    }

    return alreadyComplete
  }, [state, questionnaire, section2, section3])

  const dots = []
  
  for (let i = 1; i <= totalSteps; i++) {
    const isActive = i === currentStep
    dots.push((
      <button 
        key={`step-${i}`} 
        className={`cursor-pointer text-xs font-bold hover:shadow text-gray-500 bg-white rounded-full px-4 py-3 mt-4 hover:text-general-teal transition-all ${isActive ? 'text-general-teal shadow' : ''}`}
        onClick={() => goToStep(i)}
        disabled={i === 4 ? !state.question10 : shouldBeDisabled(i)}
      >
        {sections[i-1]}
      </button>
    ))
  }

  return (
    <nav className='nav space-x-2'>{dots}</nav>
  )
}

export default memo(NavQuiz)